module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-22-7cc8d3ca80c662e791499a0efc6c405a.png";